<div>

  @if (additionalData.isErrorIconVisible) {
    <ng-container class="icon-container">
      @if (additionalData.error || params.data['isError'] === true) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.red"
          [icon]="icons.bugOutline"
          [tooltip]="additionalData?.itemErrorIconTooltip">
        </app-display-icon>
      }
    </ng-container>
  }

  @if (additionalData.isCostMissIconVisible) {
    <ng-container class="icon-container">
      @if (additionalData.costMiss) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.yellow"
          [icon]="icons.notEqualVariant"
          [tooltip]="additionalData?.costMissIconTooltip">
        </app-display-icon>
      }
    </ng-container>
  }

  @if (additionalData.isItemRecentlyCreatedIconVisible) {
    <ng-container class="icon-container">
      @if (params.data?.['created'] >= params.data?.['suppUsedLastDate1']) {
        <app-icon-c-box-outline
          [tooltip]="additionalData?.itemRecentlyCreatedIconTooltip">
        </app-icon-c-box-outline>
      }
    </ng-container>
  }

  @if (additionalData.isItemEditedIconVisible) {
    <ng-container class="icon-container">
      @if (additionalData.isEdited && showEditedItems(params.data) !== '' && !isStockItemsUpdating) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.yellow"
          [icon]="icons.pencil"
          [tooltip]="showEditedItems(params.data)">
        </app-display-icon>
      }
    </ng-container>
  }

  @if (additionalData.isMultiplePriceChangeIconVisible) {
    <ng-container class="icon-container">
      @if (hasMultiplePriceChanges()) {
        <button
          (click)="onMultiplePriceChangeClick()"
          [attr.aria-label]="additionalData?.multiplePriceChangeIconTooltip"
          class="icon-action-button"
          type="button">
          <app-display-icon
            [border]="false"
            [colour]="iconColourEnum.primary"
            [icon]="icons.cashMultiple"
            [tooltip]="additionalData?.multiplePriceChangeIconTooltip">
          </app-display-icon>
        </button>
      }
    </ng-container>
  }

  @if (isNewItem()) {
    <app-display-icon
      [border]="false"
      [colour]="iconColourEnum.green"
      [icon]="icons.newBox"
      [tooltip]="'This Item Has Been GRVed For The First Time'">
    </app-display-icon>
  }

  @if ( params?.data?._tags?.includes('disabled')) {
    <app-display-icon
      [border]="false"
      [colour]="iconColourEnum.red"
      [icon]="icons.lockClosedOutline"
      [tooltip]="'This Item Is Disabled'">
    </app-display-icon>
  }

</div>
